export const helpArea = {
  handbook: "Hilfeartikel in unserem Helpcenter",
  video: "Anleitung als Video",
  faq: "FAQ"
};
